<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to reports list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="projects" pageId="project-summary-report" color="white"></help-link>
                    <v-menu left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                <span v-if="fiscalYear==0">&nbsp;&nbsp;CY (All)&nbsp;&nbsp;</span>
                                <span v-else>&nbsp;&nbsp;CY {{fiscalYear}}&nbsp;&nbsp;</span>
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-for="(item,index) in fiscal_years" :key="index" :title="`View Report for ${item.fiscalYear==0?'all years':item.fiscalYear}`">
                            <v-list-tile v-if="item.fiscalYear==0" @click="viewReport(item.fiscalYear)">
                                <v-list-tile-title small>CY (All)</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-else @click="viewReport(item.fiscalYear)">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-card>
            <v-layout row wrap>
                <v-flex xs12 sm2>
                    <v-card class="elavation-1" :style="isMobile?'auto':'height:385px'">
                        <v-toolbar flat height="37">
                            <b>{{ yearDescription }} Totals</b>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text style="margin-left:5px;">
                            <v-layout row>
                                <v-flex xs12 sm12>
                                    <v-chip label class="primary" dark>Projects : {{ numFormat.formatNumber(totalProjects,0) }}</v-chip>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm12>
                                    <v-chip label class="primary" dark>Tasks : {{ numFormat.formatNumber(totalProjectTasks,0) }}</v-chip>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm12>
                                    <v-chip label class="primary" dark>Charges Hours : {{ numFormat.formatNumber(totalCharges,0) }}</v-chip>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-card class="elavation-1" :style="isMobile?'auto':'height:385px'">
                        <v-toolbar flat height="37">
                            <b>{{ yearDescription }} Monthly Total Charges</b>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <div>
                                <apexchart 
                                    type="bar" 
                                    :options="barOptions" 
                                    :series="barSeries" 
                                    :height="isMobile?'':'320'"
                                    :width="isMobile?'':'100%'"/>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm5>
                    <v-card class="elavation-1" :style="isMobile?'auto':'height:385px'">
                        <v-toolbar flat height="37">
                            <b>{{ yearDescription }} Project Charges Distribution</b>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <div v-if="pieChartOptions" >
                                <apexchart 
                                    type="pie" 
                                    :options="pieChartOptions" 
                                    :series="pieChartOptions.series" 
                                    :width="isMobile?'':'500'"
                                    height="320"
                                />
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-card class="elavation-1">
                        <v-toolbar flat height="40">
                            <div class="wp-30 mb-10">
                                <v-text-field v-model="search" append-icon="search" label="Search project code, name, description, client" single-line hide-details style="margin-bottom:15px;font-weight:400;"></v-text-field>
                            </div>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-data-table
                            :headers="header"
                            :items="project_summary_filtered"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="viewTaskReport(props.item)" style="cursor:pointer;" title="Click to view project details">
                                    <td>
                                        {{ props.item.projectName }}
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.jan>0">{{ numFormat.formatNumber(props.item.jan) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.feb>0">{{ numFormat.formatNumber(props.item.feb) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.mar>0">{{ numFormat.formatNumber(props.item.mar) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.apr>0">{{ numFormat.formatNumber(props.item.apr) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.may>0">{{ numFormat.formatNumber(props.item.may) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.jun>0">{{ numFormat.formatNumber(props.item.jun) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.jul>0">{{ numFormat.formatNumber(props.item.jul) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.aug>0">{{ numFormat.formatNumber(props.item.aug) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.sep>0">{{ numFormat.formatNumber(props.item.sep) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.oct>0">{{ numFormat.formatNumber(props.item.oct) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.nov>0">{{ numFormat.formatNumber(props.item.nov) }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td class="text-xs-right">
                                        <span v-if="props.item.dec>0">{{ numFormat.formatNumber(props.item.dec) }}</span>
                                        <span v-else></span>
                                    </td>
                                </tr>
                            </template>
                            <template v-slot:footer>
                                <tr v-if="barSeries" class="caption font-weight-bold">
                                    <td><b>Monthly Total</b></td>
                                    <td>{{ getSubTotal('jan') }}</td>
                                    <td>{{ getSubTotal('feb') }}</td>
                                    <td>{{ getSubTotal('mar') }}</td>
                                    <td>{{ getSubTotal('apr') }}</td>
                                    <td>{{ getSubTotal('may') }}</td>
                                    <td>{{ getSubTotal('jun') }}</td>
                                    <td>{{ getSubTotal('jul') }}</td>
                                    <td>{{ getSubTotal('aug') }}</td>
                                    <td>{{ getSubTotal('sep') }}</td>
                                    <td>{{ getSubTotal('oct') }}</td>
                                    <td>{{ getSubTotal('nov') }}</td>
                                    <td>{{ getSubTotal('dec') }}</td>
                                </tr>
                        </template>
                        </v-data-table> 
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout> 
</template>

<script>

import projectreportsApi from '@/api/projectreports'
import numFormat from '@/common/num_format'
import VueApexCharts from "vue-apexcharts";
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'ProjectReportSummary',
    metaInfo: {
        title: 'Project Summary Report',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Project Summary Report' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        apexchart: VueApexCharts,
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            numFormat,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            fiscalYear: userPrefs.getCalendarYear(this.$route.name),
            error: false,
            errorMessage: '',
            loading: false,
            menu_status: false,
            search: null,
            project_summary: [],
        }
    },
    methods: {
        viewTaskReport(data) {
            this.$router.push(`/projects/reports/summary/${data.projectId}`)
        },
        getSubTotal(key){
            const total = this.project_summary_filtered.map(x => x[key]).reduce((prev,next) => prev+next)
            return total > 0 ? this.numFormat.formatNumber(total) : ''
        },
        viewReport(fiscalYear){
            this.fiscalYear = fiscalYear
            userPrefs.updateCalendarYear(this.$route.name, fiscalYear)
            this.getReportSummary()
        },
        async getReportSummary() {
            try{
                this.loading = true
                const response = await projectreportsApi.getSummary(this.fiscalYear)
                if (response && response.status == 200) {                  
                    this.project_summary = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.getReportSummary()

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'Projects Summary Report',
            headerPageTitle: ''
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
        fiscal_years() {
            const storePeriods = this.$store.state.fiscalPeriods
            if (storePeriods && storePeriods.length) {
                return [{ fiscalYear: 0 }, ...storePeriods]
            }
            return [{ fiscalYear: 0 }, { fiscalYear: new Date().getFullYear() }]
        },
        header() {
            let headers = []
            headers.push({ 
                text: 'Project', 
                align:'left', 
                value:'', 
                width:'35%', 
                sortable:true
            })
            for (let i = 0; i < 12; i++) {
                const monthYear = this.$moment().month(i).format('MMM');
                headers.push({
                    text: monthYear,
                    align: 'right',
                    value: monthYear.toLowerCase(),
                    width: '',
                    sortable: true
                })
            }
            return headers
        },
        totalProjects() {
            return this.project_summary.length
        },
        totalProjectTasks() {
            if (this.project_summary && this.project_summary.length) {
                return this.project_summary.map(x => x.totalTasks).reduce((prev,next) => prev+next)
            }
        },
        totalCharges() {
            if (this.project_summary && this.project_summary.length) {
                return this.project_summary.map(x => x.totalCharges).reduce((prev,next) => prev+next)
            }
        },
        project_summary_filtered() {
            if (this.search) {
                const temp = this.project_summary.filter(item => {
                    return (
                        item.projectName.toLowerCase().includes(this.search.toLowerCase())
                        || item.projectDescription.toLowerCase().includes(this.search.toLowerCase())
                        || item.projectCode.toLowerCase().includes(this.search.toLowerCase())
                        || item.client.toLowerCase().includes(this.search.toLowerCase())
                    )
                }) 
                return temp
            }
            return this.project_summary
        },
        barSeries() {
            if (this.project_summary && this.project_summary.length) {
                return [
                    {
                        name: 'Charges',
                        //note, not using formatNumber becuase it adds comma to thousands which single thousand value to 2 entries
                        data: [
                                Math.round(this.project_summary.map(x => x.jan).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.feb).reduce((prev,next) => prev+next), 2), 
                                Math.round(this.project_summary.map(x => x.mar).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.apr).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.may).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.jun).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.jul).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.aug).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.sep).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.oct).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.nov).reduce((prev,next) => prev+next), 2),
                                Math.round(this.project_summary.map(x => x.dec).reduce((prev,next) => prev+next), 2)
                            ]
                    }
                ]
            }
        },
        yearDescription(){
            return this.fiscalYear == 0 ? 'All Time' : this.fiscalYear
        },     
        projectChargesDistribution() {
            if (this.project_summary && this.project_summary.length) {
                const sortedRecords = this.project_summary.sort((a, b) => b.totalCharges - a.totalCharges);

                // Get the top 5 or fewer if there aren't enough records
                const topCount = sortedRecords.length > 5 ? 5 : sortedRecords.length;
                const topProjectCharges = sortedRecords.slice(0, topCount);

                // If there are more than 5 records, combine the remaining records
                if (sortedRecords.length > 5) {
                    const remainingRecords = sortedRecords.slice(topCount);
                    const combinedRecord = remainingRecords.reduce((acc, record) => {
                        return {
                            id: 'otherProjects',
                            projectName: 'Other Projects',
                            totalCharges: acc.totalCharges + record.totalCharges
                        };
                    }, { id: 'otherProjects', projectName: 'Other Projects', totalCharges: 0 });

                    return [...topProjectCharges, combinedRecord];
                } else {
                    return topProjectCharges;
                }
            }
        },
        pieChartOptions(){
            if (this.projectChargesDistribution && this.projectChargesDistribution.length) {
                return {
                    labels: this.projectChargesDistribution.map(x => x.projectName.length > 30 ? x.projectName.substring(0,27) + '...' : x.projectName),
                    series: this.projectChargesDistribution.map(x => x.totalCharges),
                    colors: ["#008FFB", "#00E396", "#FF4560", "#FEB019", "#775DD0", "#FF66C3"],
                    title: {
                        align: 'center',
                        style: {
                            fontSize: '8px',
                        }
                    },
                    legend: {
                        position: 'bottom'
                    },
                }
            }
        },
        barOptions() {
            return {
                chart: {
                    type: 'bar'
                },
                xaxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
                },
                title: {
                    align: 'center',
                    style: {
                        fontSize: '18px'
                    }
                },
                colors: ['#1E90FF'],
                plotOptions: {
                    bar: {
                        horizontal: false
                    }
                }
            }
        }
    }
}
</script>